import {Api} from "./request";
import {AxiosResponse} from "axios";
import {
    LoginResProps,
    Res,
    LoginReqProps,
    appListReqProps,
    queryCityReqProps,
    queryCompanyAndAppListReqProps,
    queryStatisticsReqProps,
    queryRiskListReqProps,
    queryRiskDetailReqProps,
    queryCompanyReqProps,
    appListResProps,
    getCaptchaResProps,
    queryStatisticsResProps,
    changeStarStatusProps,
} from "@/interface";

export interface IRiskDetail {
    appName: string;
    images: string[];
    releaseTime: string;
    typeFirst: string;
    typeSecond: string;
    typeTertiary: string;
    version: string;
    statute: string;
}

class BasicApi extends Api {
    login = (data: LoginReqProps) => {
        return this.axios.post<LoginReqProps, AxiosResponse<Res<LoginResProps>>>(
            "/api/v2/supervise/login",
            data,
        );
    };
    getCaptcha = () => {
        return this.axios.get<null, AxiosResponse<Res<getCaptchaResProps>>>(
            "/api/v2/users/captcha",
        );
    };
    queryAppList = (data: appListReqProps) => {
        return this.axios.post<
            appListReqProps,
            AxiosResponse<Res<appListResProps>>
        >("/api/v2/supervise/app/list", data);
    };
    queryProvinceList = () => {
        return this.axios.get<null, AxiosResponse<Res<[]>>>(
            "/api/v2/supervise/query/province",
            {},
        );
    };
    queryCityList = (data: queryCityReqProps) => {
        return this.axios.get<queryCityReqProps, AxiosResponse<Res<[]>>>(
            "/api/v2/supervise/query/city",
            {
                params: data,
            },
        );
    };
    queryCompanyAndAppList = (data: queryCompanyAndAppListReqProps) => {
        return this.axios.get<
            queryCompanyAndAppListReqProps,
            AxiosResponse<Res<[]>>
        >("/api/v2/supervise/query/app", {
            params: data,
        });
    };
    queryCompanyList = (data: queryCompanyReqProps) => {
        return this.axios.get<queryCompanyReqProps, AxiosResponse<Res<[]>>>(
            "/api/v2/supervise/query/app",
            {
                params: data,
            },
        );
    };
    queryCategoryList = () => {
        return this.axios.get<null, AxiosResponse<Res<[]>>>(
            "/api/v2/supervise/query/category",
        );
    };
    queryStatistics = (data: queryStatisticsReqProps) => {
        return this.axios.post<
            queryStatisticsReqProps,
            AxiosResponse<Res<queryStatisticsResProps>>
        >("/api/v2/supervise/app/statistics", data);
    };
    queryRiskList = (data: queryRiskListReqProps) => {
        return this.axios.get<queryRiskListReqProps, any>(
            "/api/v2/supervise/risk/list/new",
            {
                params: data,
            },
        );
    };
    queryReportList = (data: queryRiskListReqProps) => {
        return this.axios.get<queryRiskListReqProps, any>(
            "/api/v2/supervise/check/report/list",
            {
                params: data,
            },
        );
    };
    queryRiskDetail = (data: queryRiskDetailReqProps) => {
        return this.axios.get<
            queryRiskDetailReqProps,
            AxiosResponse<Res<IRiskDetail>>
        >("/api/v2/supervise/risk/detail/new", {
            params: data,
        });
    };
    exportExcel = (data: appListReqProps) => {
        return this.axios.post<appListReqProps, any>(
            "/api/v2/new/violation-queries/export",
            data,
            {responseType: "blob"},
        );
    };
    // 检测最新版本信息提交
    submitCheckInfo = (data: {
        phone: string;
        email: string;
        apkName: string;
        version: string;
        remark: string;
    }) => {

        return this.axios.post("/api/v2/supervise/check", data);
    };
    // 获取二级历史违规列表
    querySecondRiskList = (data: { tag: string }) => {
        return this.axios.get("/api/v2/supervise/regulation", {
            params: data,
        });
    };
    // 标记/取消标记
    changeStarStatus = (data: changeStarStatusProps) => {
        return this.axios.post<
            changeStarStatusProps,
            AxiosResponse<Res<LoginResProps>>
        >("/api/v2/supervise/attention", data);
    };
    // 新增/编辑个人类型备注
    changeTag = (data: { apkName: string; remark: string }) => {
        return this.axios.post("/api/v2/supervise/remark", data);
    };
    // 最新版本检测工单
    newestCheckList = (data: {
        pn: number;
        ps: number;
        level: number;
        province: string;
    }) => {
        return this.axios.get("/api/v2/supervise/check/page_list", {
            params: data,
        });
    };
    // 最新违规应用
    queryNewIllegalAppList = (data: {
        level: number;
        city?: string;
        province: string;
    }) => {
        return this.axios.get("/api/v2/supervise/risk/list_top", {
            params: data,
        });
    };
    // 最新top 10数据
    queryTopAppList = (data: {
        level: number;
        city?: string;
        province: string;
    }) => {
        return this.axios.get("/api/v2/supervise/app/inc_top", {
            params: data,
        });
    };
    // 获取地图数据
    queryMapData = () => {
        return this.axios.get("/api/v2/supervise/province/city_list");
    };

    // 获取最新版本
    getNewestVersion = (data: { apkName: string }) => {
        return this.axios("/api/v2/supervise/version", {
            params: data,
        });
    };

    // 获取数据统计截止
    getDataCollectTime = () => {
        return this.axios("/api/v2/supervise/get_last_dt");
    };

    // 获取公司、应用关联信息
    getRelateInfo = (company: string) => {
        const data = {
            inputType: "Company",
            limit: 50,
            propertyKey: "name",
            relationLevel: 3,
            propertyValue: company,
        };
        return this.axios.post("/api/v2/credits/relations", data);
    };
    // 获取开发者信誉图相关关系
    getReputationRelation = async (data: {
        inputType: string;
        propertyKey: string;
        propertyValue: string;
        relationLevel: number;
        limit: number;
        riskId?: number;
    }) => {
        const {
            inputType,
            propertyKey,
            propertyValue,
            relationLevel,
            limit,
            riskId,
        } = data;
        return await this.axios.post("/api/v2/supervise/relations", data);
    };

    // 获取省份、城市列表数据，level：1--省份  2--城市  province:省份名，查询城市时需要传递
    getProvinceOrCityList = (data: { level: number; province?: string }) => {
        return this.axios.get("/api/v2/supervise/district/list", {params: data});
        // return this.axios.get("/api/v2/district/all/list", {params: data});

    };
    getSuperviseCheckList = async (data: {
        status?: number;
        app_name?: string;
        md5?: string;
        start_time?: string;
        end_time?: string;
        pn?: number;
        ps?: number;
    }) => {
        return await this.axios.get("/api/v2/new/supervise-check/list", {
            params: data,
        });
    };
    // 获取检测报告
    getSuperviseCheckReport = async (data: { task_id?: string }) => {
        return await this.axios.get("/api/v2/new/supervise-check/report", {
            params: data,
        });
    };
    // 下载报告
    getDownloadReport = async (data: { task_id?: string; type?: number }) => {
        return await this.axios.get("/api/v2/new/supervise-check/download/report", {
            params: data,
        });
    };

    uploadUrl = (data: { fileType: string; contentType?: string }) => {
        return this.axios.get("/api/v1/oss/upload-url", {params: data});
    };
    // 创建项目
    createProject = (data: {
        version_code?: number;
        version_name?: string;
        package?: string;
        app_icon?: string;
        oss_name?: string;
        file_size?: number;
        ori_name?: string;
        msg_hash?: string;
        md5?: string;
        program?: string;
        privacy_url?: string;
    }) => {
        return this.axios.post("/api/v2/new/supervise-check/special-report/create", data);
    };


    getDisclosureCateGory = () => {
        return this.axios.get("api/v2/encyclopedia-category/category");
    };

    getDisclosureCase = (data: any) => {
        return this.axios.get("/api/v2/disclose/case", {
            params: data
        });
    };


    getDisclosureDownLoads = (data: any) => {
        return this.axios.get("/api/v2/app-announce/offline_info", {
            params: data
        });
    };


    getDisclosureSubjectEssay = (data: any) => {
        return this.axios.get("/api/v2/app-announce/get_subject_essay", {
            params: data
        });
    };

    homeCount = () => {
        return this.axios("/api/v2/industries/count")
    };

    encyclopediaCategory = () => {
        return this.axios("/api/v2/encyclopedia-category/list/gov")
    };

    specialReportList =  () => {
        return this.axios("/api/v2/new/supervise-sentiment/supervise-special-report-page?pn=1&ps=10000")
    };

    superviseActionPage = (data: any) => {
        return this.axios.get("/api/v2/new/supervise-sentiment/supervise-action-page", {
            params: data
        })
    }


    xiajiaData =  (data: any) => {
        return this.axios.get("/api/v2/industries/off-shelf-gov", {
            params: data
        })
    };
    jianceData =  (data: any) => {
        return this.axios.get("/api/v2/risk-panel/exposure/gov", {
            params: data
        })
    };

    getInstallTop = (data: any) => {
        return this.axios("/api/v2/new/dynamic_monitoring/install/top5", {
            params: data
        })
    };

    getAppTypeList = (data: any) => {
        return this.axios("/api/v2/new/dynamic_monitoring/app-type/statistics", {
            params: data
        })
    }

    getAppRiskList = (data: any) => {
        return this.axios("/api/v2/new/dynamic_monitoring/risk-type/statistics", {
            params: data
        })
    }

    getAppCategoryList = (data: any) => {
        return this.axios("/api/v2/new/dynamic_monitoring/category-trend", {
            params: data
        })
    }

    getCompanyInfo = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/company_info", {
            params: data
        })
    }

    // 按照月份返回下载量
    getMonthDownload = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/month_cnt", {
            params: data
        })
    }

    getAccDownload = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/acc_cnt", {
            params: data
        })
    }

    getAppDetail = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/app_details", {
            params: data
        })
    }

    getTrend = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/cnt_trend", {
            params: data
        })
    }

    // 下载量趋势
    getMothList = (data: any) => {
        return this.axios("/api/v2/new/violation-queries/month_cnt/list", {
            params: data
        })
    }

    // 风险问题下拉列表
    getRiskList = (data?: any) => {
        return this.axios.get("/api/v2/new/violation-queries/risk_list", {
            params: data
        })
    }

    getPrivacyList = (data?: any) => {
        return this.axios.get("/api/v2/new/violation-queries/privacy_list", {
            params: data
        })
    }

    getNewQueryStatistics = (data?: any) => {
        return this.axios.post("/api/v2/new/violation-queries/risk_app_type_total", data);
    };

    
    getNewQueryAppList = (data?: any) => {
        return this.axios.post("/api/v2/new/violation-queries/list", data);
    };

    getIsSuperUser = ()=>{
        
        return this.axios.get('/api/v2/new/dynamic_monitoring/is_super_user')
    };
    // 获取数据统计截止
    getNewDataCollectTime = () => {
        return this.axios("/api/v2/new/violation-queries/get_last_dt");
    };

     // 获取省份、城市列表数据，level：1--省份  2--城市  province:省份名，查询城市时需要传递
     getNewProvinceOrCityList = (data: { level: number; province?: string }) => {
        return this.axios.get("/api/v2/supervise/district/all/list", {params: data});
        // return this.axios.get("/api/v2/district/all/list", {params: data});

    };

    queryNewStatistics = (data: queryStatisticsReqProps) => {
        return this.axios.get("/api/v2/new/dynamic_monitoring/app/statistics", {
            params:data
        });
    };
}

export const basicApi = new BasicApi();
